export default "__VITE_ASSET__DCCnbP7N__"